module.exports = __webpack_public_path__ + "img/6ec99af.png";